import z from 'zod';

export const filterRule = z.object({
  id: z.string().min(1).describe('Unique identifier for the filter rule'),
  jsonata: z.string().min(1).describe('JSONata expression for filtering'),
  description: z.string().optional().describe('Optional description of the filter rule'),
});
export type FilterRule = z.infer<typeof filterRule>;

export const filterConfig = z.object({
  enabled: z.boolean().default(false).describe('Indicates if the filter configuration is enabled'),
  rules: z.array(filterRule).describe('Array of filter rules'),
});

export type FilterConfig = z.infer<typeof filterConfig>;
